import React from "react";
import { intersection, values, differenceWith, get, find, first } from "lodash";
import { I18n, translate } from '@td/shared_utils';
import {
  Formik,
  Form
} from "formik";
import {
  FieldLabel,
  TextField,
  SelectField,
  CheckboxField,
  FormButton,
  Text
} from "@td/ui";
import { useRuleSettings } from "../contexts/rule-settings-context";
import { SUPPORTED_CHART_TYPES } from '../constants';
import validationSchema from './rule-settings-form-validation-schema';
import styles from './styles.module.scss';

const RuleSettingsForm = () => {
  const { chartSizeScales } = useRuleSettings();
  differenceWith(values(SUPPORTED_CHART_TYPES), chartSizeScales).forEach((missingType) => {
    console.error(translate(null, "state_chart_review.config_form.supported_chart_type_missing_error"), missingType);
  });

  const chartTypeOptions = intersection(values(SUPPORTED_CHART_TYPES), chartSizeScales).map((type) => {
    return {
      value: type,
      label: translate(null, "state_chart_review.config_form.fields.chart_type.options", type),
    }
  });

  const { chartSize, chartType, mustContainRx, handleRuleUpdate } = useRuleSettings();
  const { setModalIsOpen, setChartSize, setChartType, setMustContainRx } = useRuleSettings();

  const onRulesSubmit = (values) => {
    setChartSize(parseInt(values.chartSize));
    setChartType(get(values, 'chartType.value'));
    setMustContainRx(values.mustContainRx);

    handleRuleUpdate({
      chartSize: parseInt(values.chartSize),
      chartType: get(values, 'chartType.value'),
      mustContainRx: values.mustContainRx
    });

    setModalIsOpen(false);
  };

  const initialValues = {
    chartSize: chartSize || 0,
    chartType: find(chartTypeOptions, (option) => option.value === chartType) || first(chartTypeOptions),
    mustContainRx
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onRulesSubmit}
      validationSchema={validationSchema}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <TextField
            label={translate(null, 'state_chart_review.config_form.fields.chart_size.label')}
            value={values.chartSize}
            name="chartSize"
            type="number"
            step="1"
            required
            onChange={(e) => {
              setFieldValue("chartSize", e.target.value, false);
            }}
          />
          <SelectField
            options={chartTypeOptions}
            label={translate(null, 'state_chart_review.config_form.fields.chart_type.label')}
            name="chartType"
          />
          <FieldLabel data-test-id="other-rules-section">
            <I18n scope="state_chart_review.config_form" text="other_rules_section" />

            <CheckboxField
              label={translate(null, 'state_chart_review.config_form.fields.must_contain_rx.label')}
              name="mustContainRx"
            />
          </FieldLabel>
          <Text className={styles.formDisclaimer}>
            <I18n scope="state_chart_review.config_form.modal" text="disclaimer" />
          </Text>
          <FormButton
            className={styles.formSubmitButton}
            type="submit"
            onClick={() => {}}
          >
            <I18n scope="state_chart_review.config_form" text="submit" />
          </FormButton>
        </Form>
      )}
    </Formik>
  );
};

RuleSettingsForm.propTypes = {};

export default RuleSettingsForm
